module.exports = __webpack_public_path__ + "static/media/bow-arrow.bcc198ba.svg";